import { Box, InputAdornment, TextField, Tooltip } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { useState } from 'react'

const SearchBar = ({ onChangeSearchBar, disableSearchBar }) => {
  const [searchString, setSearchString] = useState('')
  const [tooltipOpen, setTooltipOpen] = useState(false)

  const handleChange = (event) => {
    if (event.target.value.length > 0 && event.target.value.length < 3) {
      setTooltipOpen(true)
    } else {
      setTooltipOpen(false)
    }

    if (
      event.target.value.length >= 3 ||
      (searchString.length > event.target.value.length &&
        searchString.length == 3) ||
      (event.target.value.length === 0 && searchString.length >= 3)
    ) {
      onChangeSearchBar(event.target.value)
    }

    setSearchString(event.target.value)
  }

  return (
    <Box>
      <Tooltip
        open={tooltipOpen}
        title="Minimum de 3 caractères"
        arrow
        placement="top"
      >
        <TextField
          fullWidth
          variant="outlined"
          placeholder={
            disableSearchBar
              ? 'Veuillez sélectionnez une clé pour effectuer une recherche'
              : 'Recherche par clé, montant, fournisseur, référence, nom, compte...'
          }
          value={searchString}
          disabled={disableSearchBar}
          onChange={handleChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          size="small"
        />
      </Tooltip>
    </Box>
  )
}

export default SearchBar
